import { IPrinterReceiptItem } from '../../interfaces';
import { IReceiptItem } from '../../interfaces/receipt-item.interface';
import { replaceWithLatinSymbols } from '@core/services/utils/latin-symbols.utils';

export class StarReceiptItem implements IPrinterReceiptItem<IReceiptItem> {
  async getReceipt(receipt: IReceiptItem[]): Promise<IReceiptItem[]> {
    return receipt.reduce((newReceipt, item) => {
      if (item.text) {
        // Star encodes text as CP1252: Latin-1 letters (ä, é, ß) print as is, only letters beyond it like 'Ć' are transliterated.
        let text = item.text.replace(/[\u0100-\uFFFF]/g, replaceWithLatinSymbols);
        text += text.endsWith('\n') ? '' : '\n';
        item = { ...item, text };
      }
      newReceipt.push(item);
      return newReceipt;
    }, []);
  }
}
